import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject, Observable,ReplaySubject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class DataServiceService {

  constructor() { }
  public editDataDetails: any = [];
public subject = new Subject<any>();
private messageSource = new  BehaviorSubject(this.editDataDetails);
currentMessage = this.messageSource.asObservable();
menuRightsList:any []=[];
changeMessage(message: any) {
this.messageSource.next(message)
}

addMenuItem(item: any) {
  this.menuRightsList.push(item);
}

}
